import { User } from '../../lib/types/models/users/user'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getAdvisors = async () => {
  return restApiClient.url(constructApiUrl(API.enrollments.getAdvisors.url, null)).get<User[]>()
}
